import React, {
    useEffect,
    useRef,
} from "react";

import {
    useDispatch,
} from "react-redux";

import {
    useNavigate,
} from "react-router-dom";

import {
    logout,
} from "../store/slices/auth.ts";


const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /*
     * Prevent the effect from running twice under React
     * StrictMode during development.
     */
    const logoutStarted = useRef(false);

    useEffect(() => {
        if (logoutStarted.current) {
            return;
        }

        logoutStarted.current = true;

        /*
         * Clear the access token, account information, email,
         * and authentication status from Redux.
         */
        dispatch(logout());

        navigate("/", {
            replace: true,
        });
    }, [
        dispatch,
        navigate,
    ]);

    return (
        <div
            className="full-page-section bg0 flex-c-m"
            style={{
                minHeight: "60vh",
            }}
        >
            <div
                className="txt-center"
                role="status"
                aria-live="polite"
            >
                <h3 className="mtext-105 cl2 p-b-15">
                    Signing Out
                </h3>

                <p className="stext-102 cl6">
                    Clearing your account information.
                </p>
            </div>
        </div>
    );
};


export default Logout;